module.exports = __webpack_public_path__ + "fonts/THICCCBOI-ExtraBold.02638e21.ttf";